import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function updateUserPermissionsAPI(userEmail, permissions) {
  const url = `${AWS_API_URL}/user/permissions`;

  return postRequest(url, { data: { email: userEmail, permissions } }, await authorize());
}
